//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

import template from './bulk-actions-request-review-now-modal.html';

import { ICuralateStore } from '@models/AppState';
import { IShareMediaItem } from '@share/models/shareStateModel';
import getSharedItemsEligibleToRequestReviewNow from '@share/selectors/getSharedItemsEligibleToRequestReviewNow';

import angular from 'angular';
import { INgRedux } from 'ng-redux';

import { getBulkActionsSelectedItems } from 'app/bulk-actions/selectors/bulk-actions-selector';

export class BulkActionsRequestReviewNowModal {
  private static mapStateToThis(state: ICuralateStore) {
    return {
      selectedItems: getBulkActionsSelectedItems(state),
      sharedItems: state.share.data.items,
      sharedItemsEligibleToRequestReviewNow:
        getSharedItemsEligibleToRequestReviewNow(state),
    };
  }

  public selectedItems: any[];
  public sharedItems: IShareMediaItem[];
  public sharedItemsEligibleToRequestReviewNow: IShareMediaItem[];

  public eligibleToRequestReviewNow: number;
  public ineligibleToRequestReviewNow: number;

  private unsubscribe: () => void;

  constructor($ngRedux: INgRedux) {
    this.unsubscribe = $ngRedux.connect(
      BulkActionsRequestReviewNowModal.mapStateToThis,
    )(this);
  }

  public $onChanges() {
    this.eligibleToRequestReviewNow =
      this.sharedItemsEligibleToRequestReviewNow.length;
    this.ineligibleToRequestReviewNow =
      this.selectedItems.length -
      this.sharedItemsEligibleToRequestReviewNow.length;
  }

  public $onDestroy() {
    this.unsubscribe();
  }
}

angular.module('curalate').component('bulkActionsRequestReviewNowModal', {
  bindings: {
    confirmationCta: '@',
    confirmationMessage: '@',
    onCancel: '&',
    onComplete: '&',
    requiredPermission: '@',
  },
  controller: ['$ngRedux', BulkActionsRequestReviewNowModal],
  template,
});
